import React, { useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import style from "./index.module.scss";
import classNames from "classnames";
import { CourseContext } from "../../../../Store";

export default function NavBar() {
    const history = useHistory();

    const { course } = useContext(CourseContext);

    function isMatch(path: string) {
        return history.location.pathname.indexOf(path) !== -1;
    }

    return (
        <div className={style.root}>
            <div className={style.links}>
                <Link
                    className={classNames(style.link, {
                        [style.current]: isMatch("/chapter")
                    })}
                    to={`/course/${course.lmsCourseNo}/${encodeURIComponent(
                        course.courseName
                    )}`}>
                    章节
                </Link>
                <Link
                    replace
                    className={classNames(style.link, {
                        [style.current]: isMatch("/signin")
                    })}
                    to="signin">
                    签到
                </Link>
            </div>
        </div>
    );
}
